
    import './styles.scoped.css';
    export default {
  "root": "awsui_root_14iqq_17pn4_97",
  "fit-height": "awsui_fit-height_14iqq_17pn4_133",
  "with-side-media": "awsui_with-side-media_14iqq_17pn4_138",
  "variant-default": "awsui_variant-default_14iqq_17pn4_141",
  "variant-stacked": "awsui_variant-stacked_14iqq_17pn4_141",
  "refresh": "awsui_refresh_14iqq_17pn4_149",
  "sticky-enabled": "awsui_sticky-enabled_14iqq_17pn4_199",
  "with-top-media": "awsui_with-top-media_14iqq_17pn4_211",
  "content-wrapper": "awsui_content-wrapper_14iqq_17pn4_216",
  "content-wrapper-fit-height": "awsui_content-wrapper-fit-height_14iqq_17pn4_221",
  "media": "awsui_media_14iqq_17pn4_226",
  "media-top": "awsui_media-top_14iqq_17pn4_243",
  "media-side": "awsui_media-side_14iqq_17pn4_248",
  "header": "awsui_header_14iqq_17pn4_254",
  "header-with-media": "awsui_header-with-media_14iqq_17pn4_259",
  "header-sticky-disabled": "awsui_header-sticky-disabled_14iqq_17pn4_265",
  "header-sticky-enabled": "awsui_header-sticky-enabled_14iqq_17pn4_269",
  "header-stuck": "awsui_header-stuck_14iqq_17pn4_275",
  "header-variant-cards": "awsui_header-variant-cards_14iqq_17pn4_281",
  "header-dynamic-height": "awsui_header-dynamic-height_14iqq_17pn4_284",
  "with-paddings": "awsui_with-paddings_14iqq_17pn4_290",
  "with-hidden-content": "awsui_with-hidden-content_14iqq_17pn4_296",
  "header-variant-full-page": "awsui_header-variant-full-page_14iqq_17pn4_353",
  "remove-high-contrast-header": "awsui_remove-high-contrast-header_14iqq_17pn4_376",
  "dark-header": "awsui_dark-header_14iqq_17pn4_385",
  "content": "awsui_content_14iqq_17pn4_216",
  "content-fit-height": "awsui_content-fit-height_14iqq_17pn4_393",
  "content-with-media": "awsui_content-with-media_14iqq_17pn4_402",
  "footer": "awsui_footer_14iqq_17pn4_406",
  "with-divider": "awsui_with-divider_14iqq_17pn4_409"
};
  